import reducers from './reducers';

// Named exports for types, selectors, and operations
export { default as referralsTypes } from './types';
export { default as referralsSelectors } from './selectors';
export { default as referralsOperations } from './operations';

// Default export is the reducers
export default reducers;
